template.load(function (data) {
    var app = this;
    var _ = app.getLibrary('_');
    var $ = app.getLibrary('$');
    var url = app.getLibrary('url');

    var elements = {};
    var sortOrder = null;

    var setSorting = function (sort, order) {
        var link = url.current();

        link.query = _.omit(link.query, ['order']);
        link.query['sort'] = sort;

        if (!_.isNil(order))
            link.query['order'] = order;

        sortOrder = order;

        url.go(link);
    };

    var sortPopupState = false;

    elements.root = data.nodes;
    elements.sort = $('[data-role="catalog.panel.sort"]', elements.root);
    elements.sortButton = $('[data-role="catalog.panel.sortButton"]', elements.sort);
    elements.sortItems = $('[data-role="catalog.panel.sortItems"]', elements.sort);
    elements.sortSelection = $('[data-role="catalog.panel.sortSelection"]', elements.root);



    elements.sortButton.on('click', function (event) {
        var self = $(this);
        var target = $(event.target);

        if (target.isOrClosest(elements.sortItems))
            return;

        sortPopupState = !sortPopupState;

        if (sortPopupState) {
            elements.sortItems.show();
        } else {
            elements.sortItems.hide();
        }
    });

    elements.sortSelection.on('click', function (event) {
        var active;

        if (event.target.tagName !== 'INPUT') {
            active = this.getAttribute('data-active') === 'true';

            setSorting(this.getAttribute('data-value'), !active ? this.getAttribute('data-order') : null);
        }
    });

}, {
    'name': '[Component] bitrix:news.detail (brands.default.1) sort',
    'nodes': '[data-role="catalog.panel"]',
    'loader': {
        'name': 'lazy'
    }
});

template.load(function (data) {
    var $ = this.getLibrary('$');

    var root = data.nodes;
    var toggle = $('[data-role="brand-toggle"]', root);

    toggle.on('click', function () {
        var wrap = $(this).closest('[data-state]');
        var expanded = wrap.attr('data-state') === 'expanded';

        wrap.attr('data-state', expanded ? 'collapsed' : 'expanded');
        $(this).find('[data-role="brand-toggle-label"]').text(expanded ? 'Развернуть' : 'Свернуть');
    });
}, {
    'name': '[Component] bitrix:news.detail (brands.default.1) brand-toggle',
    'nodes': '[data-role="brand-texts"]',
    'loader': {
        'name': 'lazy'
    }
});
